import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";

import LoginForm from "@client/components/modules/Login/Form";
import licensorStore from "@client/stores/LicensorStore";

import backgroundImage from "./images/background.png";
import cbslLogo from "./images/cbsl-logo.svg";
import coriolisLogo from "./images/coriolis-logo-large.svg";

const Wrapper = styled.div`
  background-image: url("${backgroundImage}");
  background-color: transparent;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  position: absolute;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 77px;
  flex-shrink: 0;
`;
const Logo = styled.div`
  width: 256px;
  height: 312px;
  background: url(${coriolisLogo}) center no-repeat;
`;
const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  margin: 48px 0;
`;
const FooterText = styled.div`
  font-size: 12px;
  color: white;
  margin-bottom: 16px;
`;
const CbsLogo = styled.a`
  width: 128px;
  height: 32px;
  background: url("${cbslLogo}") center no-repeat;
  cursor: pointer;
`;

interface Props {
  onNavigate: (path: string) => void;
}

@observer
class LoginPage extends React.Component<Props> {
  async handleFormSubmit(username: string, password: string) {
    const isSuccess = await licensorStore.login(username, password);
    if (isSuccess) {
      const prevExp = /\?prev=(.*)/;
      const prevMatch =
        prevExp.exec(window.location.hash) ||
        prevExp.exec(window.location.search);
      if (prevMatch) {
        this.props.onNavigate(prevMatch[1]);
      } else {
        this.props.onNavigate("/");
      }
    }
  }

  render() {
    return (
      <Wrapper>
        <Content>
          <Top>
            <Logo />
            <LoginForm
              onSubmit={(u, p) => {
                this.handleFormSubmit(u, p);
              }}
              disabled={licensorStore.loggingIn}
              errorMessage={licensorStore.loginErrorMessage}
            />
          </Top>
          <Footer>
            <FooterText>Coriolis® is a service created by</FooterText>
            <CbsLogo href="https://cloudbase.it" target="_blank" />
          </Footer>
        </Content>
      </Wrapper>
    );
  }
}

function LoginPageWithNavigate() {
  const navigate = useNavigate();
  return <LoginPage onNavigate={navigate} />;
}

export default LoginPageWithNavigate;
